import { multipleActionToastPreset } from './presets/multiple-action.toast.preset';
import { simpleTimedToastPreset } from './presets/simple-timed.toast.preset';
import { singleActionTimedToastPreset } from './presets/single-action-timed.toast.preset';

export function configureMdToastProvider($mdToastProvider) {
    'ngInject';

    $mdToastProvider.addPreset(multipleActionToastPreset.name, multipleActionToastPreset);
    $mdToastProvider.addPreset(simpleTimedToastPreset.name, simpleTimedToastPreset);
    $mdToastProvider.addPreset(singleActionTimedToastPreset.name, singleActionTimedToastPreset);
}



// WEBPACK FOOTER //
// ./src/lib/components/toast/md-toast-provider.config.ts